import {
  Component,
  input,
  output,
  inject,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { LowerCasePipe, CurrencyPipe, CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { StoreService } from 'src/app/core/services/store.service';

@Component({
  selector: 'app-product-grid',
  templateUrl: './product-grid.component.html',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    LowerCasePipe,
    CurrencyPipe,
    NgxPaginationModule,
  ],
})
export class ProductGridComponent {
  store = inject(StoreService);

  products    = input.required<any[]>();
  storeName   = input.required<string>();       // the :name route param
  currentPage = input.required<number>();
  totalItems  = input.required<number>();
  totalElements = input.required<number>();
  lastPage    = input.required<number>();
  cart        = input<any[]>([]);

  pageChanged   = output<number>();
  addToCart     = output<{ code: string; index: number }>();
}
